import getters from './getters'

const state = {
  database: {
    // TODO...
  },
  PersonalBill: {
    Water: {},
    Cash: {},
    Card: {}
  },
  title: 'cpm-customer-wechat'
}

const mutations = {
  setData (state, jsonObj) {
    for (let key in jsonObj) {
      state.database[key] = jsonObj[key]
    }
  },
  removeData (state, key) {
    delete state.database[key]
  },
  setWater (state, jsonObj) {
    let tempWater = {}
    for (let key in jsonObj) {
      tempWater[key] = jsonObj[key]
    }
    state.PersonalBill.Water = tempWater
  },
  setCash (state, jsonObj) {
    let tempCash = {}
    // debugger
    for (let key in jsonObj) {
      tempCash[key] = jsonObj[key]
    }
    state.PersonalBill.Cash = tempCash
  },
  setCard (state, jsonObj) {
    let tempCard = {}
    for (let key in jsonObj) {
      tempCard[key] = jsonObj[key]
    }
    state.PersonalBill.Card = tempCard
  },
  setTitle (state, title) {
    state.title = title
  }
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/data/mutations.js